import React, { useEffect, createContext, useState } from "react";
import AOS from "aos";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrolltoTop from "./components/Main/ScrolltoTop";
import Home from "./screens/Home";
import Events from "./screens/Events";
import EventsDetails from "./screens/EventsDetails";
import Errorpage from "./components/Main/Error";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();
// export const languages = { ENGLISH: "English", ARABIC: "Arabic" };
export const LanguageContext = createContext();

function App() {
  AOS.init({
    once: true,
  });
  const [language, setLanguage] = useState("ENGLISH");
  const [languages, setLanguages] = useState({
    ENGLISH: "English",
    ARABIC: "Arabic",
  });

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, languages, setLanguages }}
    >
      <QueryClientProvider client={queryClient}>
        <div className={`App ${language === "ARABIC" ? "rtl" : ""}`}>
          <Router>
            <ScrolltoTop>
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/events" component={Events} />
                <Route
                  path="/events/:status/:eventsId"
                  component={EventsDetails}
                />
                <Route component={Errorpage} />
              </Switch>
            </ScrolltoTop>
          </Router>
        </div>
      </QueryClientProvider>
    </LanguageContext.Provider>
  );
}

export default App;
